module.exports = __webpack_public_path__ + "static/media/close.649d3ef7.svg";